// extracted by mini-css-extract-plugin
module.exports = {"SidebarInfo":"_3qg91n8D","label":"_3nTf5JZG","header":"_9WnBJ2pc","content":"_1NWc4WMw"};